import { NgModule, APP_INITIALIZER, ErrorHandler  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, RouteReuseStrategy } from '@angular/router';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { REQUEST, RESPONSE, DEVICE_INFO } from 'angular-engine/modules/ng-express-engine/tokens';
import { AppComponent } from 'angular-framework-client-components/app.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TransferHttpModule } from 'angular-engine/modules/transfer-http/transfer-http.module';
import { ApiDataModule } from 'angular-engine/engine/service/data/module/api.data.module';
import { UserApiModule } from 'angular-engine/engine/service/user/module/user.api.module';
import { NotificationApiModule } from 'angular-engine/engine/service/notification/module/notification.api.module';
import { DynamicInteractionModule } from 'angular-engine/engine/service/dynamic/module/dynamic.interaction.module';
import { UiServicesModule } from 'angular-engine/engine/service/ui/module/ui.services.module';
import { OtherServicesModule } from 'angular-engine/engine/service/util/module/other.services.module';
import { MetaServiceModule } from "angular-engine/engine/service/meta/";
import { reducer, initialDataState } from 'angular-engine/engine/state/reducer/core.reducer';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { InternalEffectsModule } from 'angular-engine/engine/state/effect/effects.module';
import { StatePrepareGuard } from "angular-engine/engine/state/guard/state.prepare";
import { ScrollerModule } from 'angular-shared-features/feature/scroller/module/scroller.module';
import { ImagesModule } from 'angular-shared-features/feature/custom-image/module/image-module';
import { SharedDirectivesModule } from 'angular-shared-features/feature/shared-directives/module/shared.directives.module';
import { SharedPipesModule } from 'angular-shared-features/feature/shared-pipe/module/shared.pipes.module';
import { SharedComponentsModule } from 'angular-shared-features/feature/shared-component/module/shared-component.module';
import { SidebarModule } from 'ng-sidebar';
import { PresentationalComponentsModule } from 'angular-framework-client-components/components/components.module';
import { ContainerComponentsModule } from 'angular-framework-client-components/containers/containers.module';
import { AppRoutingModule } from 'angular-framework-client-components/model/app.router.module';//'./app.router.module';
import { VgCoreModule } from "videogular2/core";
import { VgControlsModule } from "videogular2/controls";
import { VgOverlayPlayModule } from "videogular2/overlay-play";
import { VgBufferingModule } from "videogular2/buffering";
import { VgStreamingModule } from "videogular2/streaming";
//import { SwiperModule } from 'angular-shared-features/feature/swiper/module/swiper.module';
import { DynamicComponentModule } from 'angular-framework-client-components/containers/notfound-container/dynamic.component.module';
import { CustomRouteReuseStrategy } from './custom-reuse-strategy';
import { ClipboardModule } from 'ngx-clipboard';
//import { SearchServiceModule } from 'angular-engine/engine/service/search/module/search.service.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { MatDatepickerModule } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MomentModule } from 'ngx-moment';
import { AngularDraggableModule } from 'angular2-draggable';
import { LightboxModule } from 'ngx-lightbox';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    HttpModule,
    HttpClientModule,
    TransferHttpModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    SidebarModule.forRoot(),
    ApiDataModule,
    OtherServicesModule,
    //SearchServiceModule,
    MetaServiceModule,
    UiServicesModule,
    ScrollerModule,
    ImagesModule,
    SharedPipesModule,
    SharedDirectivesModule,
    SharedComponentsModule,
    DynamicInteractionModule,
    DynamicComponentModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    VgStreamingModule,
    PresentationalComponentsModule,
    ContainerComponentsModule,
    AppRoutingModule,
    StoreModule.forRoot({reducer:reducer}),
    EffectsModule.forRoot([CoreEffects]),
    InternalEffectsModule,
    (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'stageprod') ? [] : StoreDevtoolsModule.instrument({ maxAge: 30 }),
    //SwiperModule,
    ClipboardModule,
    //SearchServiceModule,
    OAuthModule.forRoot(),
    UserApiModule,
    NotificationApiModule,
    MatDatepickerModule, MatMomentDateModule,
    MomentModule,
    AngularDraggableModule,
    LightboxModule
  ],
  providers: [
    ErrorHandler,
    StatePrepareGuard,
    { provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy
    }
  ],
  declarations: [AppComponent],
  exports: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts